import React, { FC } from "react";

import style from "./CardImage.module.scss";

export interface CardImageProps {
  url: string;
}

export const CardImage: FC<CardImageProps> = ({ url }) => (
  <div className={style.image} style={{ backgroundImage: `url(${url})` }} />
);
